import createPlotlyComponent from "react-plotlyjs";
import React, { PureComponent } from "react";
import Plotly from "plotly.js/dist/plotly-basic";
import CheckIcon from "@material-ui/icons/CheckCircle";

import styled from "styled-components";

export const Wrapper = styled.div`
  &&& {
    position: relative;

    margin-top: 24px;

    .benchmarks {
      @media print {
        position: absolute;
        top: 10px;
        left: -14px;
      }
    }

    .pass-check {
      position: absolute;
      top: -9px;
      z-index: 1;
      color: #1cc7a0;
      font-size: 28px;

      &.first {
        left: 208.5px;
        @media print {
          left: 194.5px;
        }
      }
      &.second {
        left: 370.5px;
        @media print {
          left: 356.5px;
        }
      }
      &.third {
        left: 532.5px;
        @media print {
          left: 518.5px;
        }
      }
      &.fourth {
        left: 694.5px;
        @media print {
          left: 680.5px;
        }
      }
    }

    .benchmark {
      width: 120px;
      height: 4px;
      position: absolute;
      background: #00c4ff;
      top: 34px;
      z-index: 1;

      &.first {
        left: 164px;
      }
      &.second {
        left: 325px;
      }
      &.third {
        left: 487px;
      }
      &.fourth {
        left: 649px;
      }
    }
    .js-plotly-plot {
    }
    .svg-container {
      margin: auto;
      margin-top: 10px;
      margin-right: 0;
    }
    .main-svg {
      overflow: visible;
    }
    rect {
      cursor: default !important;
    }

    .whatever svg:last-child {
      @media print {
        transform: translateY(-254px);
      }
    }
  }
`;

const PlotlyComponent = createPlotlyComponent(Plotly);

export default class PlotlyBar extends PureComponent {
  render() {
    const { x, y, benchmarks } = this.props;

    const data = [
      {
        type: "bar",
        x,
        y,
        marker: {
          color: "#2c6c90",
        },
      },
    ];

    for (let i = 0; i < y.length; i++) {
      if (y[i] === "--") {
        y[i] = 0;
      }
    }

    const layout = {
      width: 800,
      height: 250,
      margin: {
        t: 20,
        r: 38,
        b: 30,
        l: 115,
      },
      yaxis: {
        title: "Unit Domain Score",
        fixedrange: true,
        autorange: false,
        range: [-10, 110],
        zeroline: false,
        dtick: 50,
        titlefont: { family: "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif", color: "#aaa", size: 12 },
        tickfont: { family: "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif", color: "#aaa", size: 12 },
      },
      xaxis: {
        tickfont: { family: "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif", color: "#aaa", size: 12 },
        fixedrange: true,
      },
      bargap: 0.5,
    };

    const config = {
      displayModeBar: false,
    };

    const pass = [y[0] > benchmarks[0], y[1] > benchmarks[1], y[2] > benchmarks[2], y[3] > benchmarks[3]];

    const benchmarkBarTop = [
      200 - 166 * benchmarks[0] * 0.01,
      200 - 166 * benchmarks[1] * 0.01,
      200 - 166 * benchmarks[2] * 0.01,
      200 - 166 * benchmarks[3] * 0.01,
    ];

    const passCheckTop = [
      157 - 166 * y[0] * 0.01,
      157 - 166 * y[1] * 0.01,
      157 - 166 * y[2] * 0.01,
      157 - 166 * y[3] * 0.01,
    ];

    return (
      <Wrapper>
        <div className="benchmarks">
          {!!benchmarkBarTop[0] && <div className="benchmark first" style={{ top: benchmarkBarTop[0] }} />}
          {!!benchmarkBarTop[1] && <div className="benchmark second" style={{ top: benchmarkBarTop[1] }} />}
          {!!benchmarkBarTop[2] && <div className="benchmark third" style={{ top: benchmarkBarTop[2] }} />}
          {!!benchmarkBarTop[3] && <div className="benchmark fourth" style={{ top: benchmarkBarTop[3] }} />}
        </div>
        <div>
          <CheckIcon
            className="pass-check first"
            style={{ top: passCheckTop[0], color: pass[0] ? "" : "transparent" }}
          />
          <CheckIcon
            className="pass-check second"
            style={{ top: passCheckTop[1], color: pass[1] ? "" : "transparent" }}
          />
          <CheckIcon
            className="pass-check third"
            style={{ top: passCheckTop[2], color: pass[2] ? "" : "transparent" }}
          />
          <CheckIcon
            className="pass-check fourth"
            style={{ top: passCheckTop[3], color: pass[3] ? "" : "transparent" }}
          />
        </div>
        <PlotlyComponent className="whatever" data={data} layout={layout} config={config} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/plotly/UnitMagnetScores.jsx